import React from 'react';
export const Nav01DataSource = (t)=>({
  wrapper: { className: 'header0 home-page-wrapper' },
  page: { className: 'home-page' },
  logo: {
    className: 'header0-logo',
    children: 'https://www.bmr-oe.com/static/images/logo15.png',
  },
  Menu: {
    className: 'header0-menu',
    children: [
      {
        name: 'item~mf14rf6vwrk',
        className: 'header0-item',
        children: {
          href: '/#',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <p>{t('4PCGdBlDyPUCWaaUQQspa')}</p>
                    </span>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item0',
        className: 'header0-item',
        children: {
          href: '#',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <p>{t('7pDkIkL0xQOZRr0jEsWfH')}</p>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
        subItem: [
          {
            name: 'sub0',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m9l2x14xpk-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/强激光78.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8wyzpxxeu-editor_css',
                  children: (
                    <span>
                      <span>
                        <p>{t('-c77KTdikVdLnZyASK3Cc')}</p>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second1',
            },
          },
          {
            name: 'sub1',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/通用双轴50.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <p>{t('wrYpuBolo6Y-66rfMCmBQ')}</p>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second2',
            },
          },
          {
            name: 'sub~m8x12rhcd3r',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/单轴50.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <p>{t('XIIWOmNiax-MGLN70STnp')}</p>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second3',
            },
          },
          {
            name: 'sub~m8x12unqvh',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/摆扫镜30.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <span>
                                <span>
                                  <span>
                                    <p>{t('QKidfeXu-G3Pbhj3ugFWP')}</p>
                                  </span>
                                </span>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second4',
            },
          },
          {
            name: 'sub~m8x12vr6qz',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/振镜6240.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <span>
                                <span>
                                  <p>{t('aZYz5hutoL-vR2EYFwzjK')}</p>
                                </span>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second5',
            },
          },
          {
            name: 'sub~m8x12wndado',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/电调镜78.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <p>{t('WzbR-QB6ybE9kd_x9Jdec')}</p>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second6',
            },
          },
          {
            name: 'sub~m8x12xgznka',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/电动镜127.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <p>{t('_DsCjfhb6qdkN8xDndgvv')}</p>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second7',
            },
          },
          {
            name: 'sub~m8x12yp8s7o',
            className: 'item-sub m976jn6jedn-editor_css',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/激光通信20.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <span>
                                <span>
                                  <span>
                                    <span>
                                      <span>
                                        <span>
                                          <span>
                                            <p>{t('w27MxRSEJmuPk0gtJ1j0-')}</p>
                                          </span>
                                        </span>
                                      </span>
                                    </span>
                                  </span>
                                </span>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second8',
            },
          },
          {
            name: 'sub~m9l31knlmcb',
            className: 'item-sub m976jn6jedn-editor_css',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/永磁同步75.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <span>
                                <span>
                                  <span>
                                    <span>
                                      <span>
                                        <span>
                                          <p>{t('pSpQcC-g9WCZpR8HFrIWa')}</p>
                                        </span>
                                      </span>
                                    </span>
                                  </span>
                                </span>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second9',
            },
          },
        ],
      },
      {
        name: 'item1',
        className: 'header0-item',
        children: {
          href: '/#/fourth',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <span>
                            <p>{t('pChfBIJCqSzYe-o9E4WXs')}</p>
                          </span>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item2',
        className: 'header0-item',
        children: {
          href: '/#/tenth',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <p>{t('aKo75TzuObF4iDSxrxkCj')}</p>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item3',
        className: 'header0-item',
        children: {
          href: '/#/fifth',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <p>{t('VSG7AfVtQEYz3Wq4Bx3QO')}</p>
                    </span>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item~m98oygx0zqi',
        className: 'header0-item',
        children: {
          href: '/#/sixth',
          children: [
            {
              children: (
                <span>
                  <span>
                    <p>{t('UtSi0nSsnC17KU7hO3HAk')}</p>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
      },
    ],
  },
  mobileMenu: { className: 'header0-mobile-menu' },
});
export const Banner10DataSource = (t)=>({
  wrapper: { className: 'banner1 m8wmyqt62ma-editor_css' },
  BannerAnim: {
    children: [
      {
        name: 'elem0',
        BannerElement: { className: 'banner-user-elem' },
        textWrapper: { className: 'banner1-text-wrapper' },
        bg: { className: 'bg bg0 m8wmxqt4hsf-editor_css' },
        title: { className: 'banner1-title', children: '' },
        content: {
          className: 'banner1-content m8wt5yzvohu-editor_css',
          children: (
            <span>
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <blockquote>
                                {t('HmqJxPcfXfQeNTIXp5w1K')}
                              </blockquote>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            </span>
          ),
        },
        button: {
          className: 'banner1-button m8wtjvr1hjk-editor_css',
          children: (
            <span>
              <span>
                <p>
                  <br />
                </p>
              </span>
            </span>
          ),
        },
      },
      {
        name: 'elem2',
        BannerElement: { className: 'banner-user-elem' },
        textWrapper: { className: 'banner1-text-wrapper' },
        bg: { className: 'bg bg1 m96u0zciy-editor_css' },
        title: { className: 'banner1-title', children: '' },
        content: {
          className: 'banner1-content m96ve128cj-editor_css',
          children: (
            <span>
              <span>
                <span>
                  <span>
                    <span>
                      <p>{t('on-cE77fbckQNsjJr8RtQ')}</p>
                      <p>{t('Si_FFQuwIflGlafnhE2Fx')}</p>
                    </span>
                  </span>
                </span>
              </span>
            </span>
          ),
        },
        button: {
          className: 'banner1-button m96u6oixptm-editor_css',
          children: (
            <span>
              <p>
                <br />
              </p>
            </span>
          ),
        },
      },
    ],
    autoPlay: true,
    type: ['across'],
    autoPlaySpeed: 5000,
  },
});
export const Content90DataSource = (t)=>({
  wrapper: { className: 'home-page-wrapper content9-wrapper' },
  page: { className: 'home-page content9' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'image',
        children:
          'https://gw.alipayobjects.com/zos/rmsportal/PiqyziYmvbgAudYfhuBr.svg',
        className: 'title-image',
      },
      {
        name: 'title',
        children: (
          <div>
            <h1>{t('iLANfP0_7eLnzUjJUFPtx')}</h1>
          </div>
        ),
        className: 'title-h1',
      },
    ],
  },
  block: {
    className: 'timeline',
    children: [
      {
        name: 'block1',
        className: 'block-wrapper',
        playScale: 0.3,
        children: {
          imgWrapper: { className: 'image-wrapper' },
          content: {
            className: 'block-content m9qxz7uawka-editor_css',
            children: (
              <span>
                <span>
                  <p>{t('1QljJO30DPKdkZnGU4hDD')}</p>
                </span>
              </span>
            ),
          },
          name: {
            className: 'block-name',
            children: (
              <span>
                <p>
                  <br />
                </p>
              </span>
            ),
          },
          textWrapper: { className: 'text-wrapper' },
          time: {
            className: 'block-time m9qxyzevsc-editor_css',
            children: (
              <span>
                <p>{t('hu-suxaJKhAP7OXjmWQT5')}</p>
              </span>
            ),
          },
          icon: {
            className: 'block-icon',
            children:
              'https://gw.alipayobjects.com/zos/rmsportal/QviGtUPvTFxdhsTUAacr.svg',
          },
          title: {
            className: 'block-title m9qxz49g91l-editor_css',
            children: (
              <span>
                <p>{t('AhvXqYGl6NWkia-1PWnBF')}</p>
              </span>
            ),
          },
          post: {
            className: 'block-post',
            children: (
              <span>
                <p>
                  <br />
                </p>
              </span>
            ),
          },
          img: {
            className: 'block-img',
            children:
              'https://www.bmr-oe.com/static/images/app/证书.png',
          },
        },
      },
      {
        name: 'block2',
        className: 'block-wrapper',
        playScale: 0.3,
        children: {
          imgWrapper: { className: 'image-wrapper' },
          content: {
            className: 'block-content m9qym0wev6b-editor_css',
            children: (
              <span>
                <span>
                  <p>{t('JyQdyOFwZbblMuRR99Cox')}</p>
                </span>
              </span>
            ),
          },
          name: {
            className: 'block-name',
            children: (
              <span>
                <span>
                  <p>
                    <br />
                  </p>
                </span>
              </span>
            ),
          },
          textWrapper: { className: 'text-wrapper' },
          time: {
            className: 'block-time m9qylxk50id-editor_css',
            children: (
              <span>
                <p>{t('8hh7uzet4nPiVDSw_4qgd')}</p>
              </span>
            ),
          },
          icon: {
            className: 'block-icon',
            children:
              'https://gw.alipayobjects.com/zos/rmsportal/QviGtUPvTFxdhsTUAacr.svg',
          },
          title: {
            className: 'block-title m9qyltyjxb6-editor_css',
            children: (
              <span>
                <p>{t('55Sg4zgTG6w9vEK1gxVfp')}</p>
              </span>
            ),
          },
          post: {
            className: 'block-post',
            children: (
              <span>
                <p>
                  <br />
                </p>
              </span>
            ),
          },
          img: {
            className: 'block-img',
            children:
              'https://www.bmr-oe.com/static/images/app/奖状.png',
          },
        },
      },
      {
        name: 'block3',
        className: 'block-wrapper',
        playScale: 0.3,
        children: {
          imgWrapper: { className: 'image-wrapper' },
          content: {
            className: 'block-content m9qymonevfh-editor_css',
            children: (
              <span>
                <p>
                  {t('bSTTNpPiMSpea2OwS3YqQ')}
                </p>
              </span>
            ),
          },
          name: {
            className: 'block-name',
            children: (
              <span>
                <p>
                  <br />
                </p>
              </span>
            ),
          },
          textWrapper: { className: 'text-wrapper' },
          time: {
            className: 'block-time m9qymj8ukzl-editor_css',
            children: (
              <span>
                <p>{t('tCHXmr-Fz80BV77B8nNWt')}</p>
              </span>
            ),
          },
          icon: {
            className: 'block-icon',
            children:
              'https://gw.alipayobjects.com/zos/rmsportal/agOOBdKEIJlQhfeYhHJc.svg',
          },
          title: {
            className: 'block-title m9qymicg27q-editor_css',
            children: (
              <span>
                <p>{t('wle71S1z2iUifEGyLcFNc')}</p>
              </span>
            ),
          },
          post: {
            className: 'block-post',
            children: (
              <span>
                <p>
                  <br />
                </p>
              </span>
            ),
          },
          img: {
            className: 'block-img',
            children:
              'https://www.bmr-oe.com/static/images/app/奖状.png',
          },
        },
      },
      {
        name: 'block~m9qxpp9qkro',
        className: 'block-wrapper',
        playScale: 0.3,
        children: {
          imgWrapper: { className: 'image-wrapper' },
          content: {
            className: 'block-content m9qymy5bfak-editor_css',
            children: (
              <span>
                <span>
                  <p>
                    {t('Y-XD9fGROvSM2wW2f3waV')}
                  </p>
                </span>
              </span>
            ),
          },
          name: {
            className: 'block-name',
            children: (
              <span>
                <p>
                  <br />
                </p>
              </span>
            ),
          },
          textWrapper: { className: 'text-wrapper' },
          time: {
            className: 'block-time m9qymyltout-editor_css',
            children: (
              <span>
                <p>{t('a8ib8AkCKeIISEcg3xAyH')}</p>
              </span>
            ),
          },
          icon: {
            className: 'block-icon',
            children:
              'https://gw.alipayobjects.com/zos/rmsportal/agOOBdKEIJlQhfeYhHJc.svg',
          },
          title: {
            className: 'block-title m9qyn1tqz-editor_css',
            children: (
              <span>
                <p>{t('Yu4CQetrV6iBETiBXpf2V')}</p>
              </span>
            ),
          },
          post: {
            className: 'block-post',
            children: (
              <span>
                <p>
                  <br />
                </p>
              </span>
            ),
          },
          img: {
            className: 'block-img',
            children:
              'https://www.bmr-oe.com/static/images/app/展会.png',
          },
        },
      },
      {
        name: 'block~m9qxprjno4',
        className: 'block-wrapper',
        playScale: 0.3,
        children: {
          imgWrapper: { className: 'image-wrapper' },
          content: {
            className: 'block-content m9qynddmbn9-editor_css',
            children: (
              <span>
                <p>
                  {t('i2TI3yTXDC5Nu57XpgbXA')}
                </p>
              </span>
            ),
          },
          name: {
            className: 'block-name',
            children: (
              <span>
                <p>
                  <br />
                </p>
              </span>
            ),
          },
          textWrapper: { className: 'text-wrapper' },
          time: {
            className: 'block-time m9qyn7yig7g-editor_css',
            children: (
              <span>
                <p>{t('xvWXG_2ydvGYuc8GWjSDZ')}</p>
              </span>
            ),
          },
          icon: {
            className: 'block-icon',
            children:
              'https://gw.alipayobjects.com/zos/rmsportal/agOOBdKEIJlQhfeYhHJc.svg',
          },
          title: {
            className: 'block-title m9qyna5xj1-editor_css',
            children: (
              <span>
                <p>{t('M95rQcoji_SD0KIDr79QA')}</p>
              </span>
            ),
          },
          post: {
            className: 'block-post',
            children: (
              <span>
                <p>
                  <br />
                </p>
              </span>
            ),
          },
          img: {
            className: 'block-img',
            children:
              'https://www.bmr-oe.com/static/images/app/展会.png',
          },
        },
      },
      {
        name: 'block~m9qxptkrm3g',
        className: 'block-wrapper',
        playScale: 0.3,
        children: {
          imgWrapper: { className: 'image-wrapper' },
          content: {
            className: 'block-content m9qynyr2w8-editor_css',
            children: (
              <span>
                <p>
                  {t('mk39tBhzsoGVZHC9l16NT')}
                </p>
              </span>
            ),
          },
          name: {
            className: 'block-name',
            children: (
              <span>
                <span>
                  <p>
                    <br />
                  </p>
                </span>
              </span>
            ),
          },
          textWrapper: { className: 'text-wrapper' },
          time: {
            className: 'block-time m9qyns2s8k-editor_css',
            children: (
              <span>
                <p>{t('SK_R0Sgn3rTR34mh8CvCR')}</p>
              </span>
            ),
          },
          icon: {
            className: 'block-icon',
            children:
              'https://gw.alipayobjects.com/zos/rmsportal/agOOBdKEIJlQhfeYhHJc.svg',
          },
          title: {
            className: 'block-title m9qynue8wk-editor_css',
            children: (
              <span>
                <p>{t('X0BhM8Oz4ljzeR766OG6y')}</p>
              </span>
            ),
          },
          post: {
            className: 'block-post',
            children: (
              <span>
                <p>
                  <br />
                </p>
              </span>
            ),
          },
          img: {
            className: 'block-img',
            children:
              'https://www.bmr-oe.com/static/images/app/展会.png',
          },
        },
      },
      {
        name: 'block~mf11zi5djir',
        className: 'block-wrapper',
        playScale: 0.3,
        children: {
          imgWrapper: { className: 'image-wrapper' },
          content: {
            className: 'block-content m9qynyr2w8-editor_css',
            children: (
              <span>
                <p>
                  {t('PxMX0trBpoKLU_5XZYwIb')}
                </p>
              </span>
            ),
          },
          name: {
            className: 'block-name',
            children: (
              <span>
                <span>
                  <p>
                    <br />
                  </p>
                </span>
              </span>
            ),
          },
          textWrapper: { className: 'text-wrapper' },
          time: {
            className: 'block-time m9qyns2s8k-editor_css',
            children: (
              <span>
                <span>
                  <p>{t('0I5v7tOQ1b7YhLT_pWc9w')}</p>
                </span>
              </span>
            ),
          },
          icon: {
            className: 'block-icon',
            children:
              'https://gw.alipayobjects.com/zos/rmsportal/agOOBdKEIJlQhfeYhHJc.svg',
          },
          title: {
            className: 'block-title m9qynue8wk-editor_css',
            children: (
              <span>
                <span>
                  <span>
                    <p>{t('z-FP2C2ht6QomR06eROdJ')}</p>
                  </span>
                </span>
              </span>
            ),
          },
          post: {
            className: 'block-post',
            children: (
              <span>
                <p>
                  <br />
                </p>
              </span>
            ),
          },
          img: {
            className: 'block-img',
            children:
              'https://www.bmr-oe.com/static/images/app/展会.png',
          },
        },
      },
            {
        name: 'block8',
        className: 'block-wrapper',
        playScale: 0.3,
        children: {
          imgWrapper: { className: 'image-wrapper' },
          content: {
            className: 'block-content m9qynyr2w8-editor_css',
            children: (
              <span>
                <p>
                  {t('ynzRvrt6BX2fbpNsqyCH6')}
                </p>
              </span>
            ),
          },
          name: {
            className: 'block-name',
            children: (
              <span>
                <span>
                  <p>
                    <br />
                  </p>
                </span>
              </span>
            ),
          },
          textWrapper: { className: 'text-wrapper' },
          time: {
            className: 'block-time m9qyns2s8k-editor_css',
            children: (
              <span>
                <span>
                  <p>{t('hfYn9Sj1xMDMUglu6Amtt')}</p>
                </span>
              </span>
            ),
          },
          icon: {
            className: 'block-icon',
            children:
              'https://gw.alipayobjects.com/zos/rmsportal/agOOBdKEIJlQhfeYhHJc.svg',
          },
          title: {
            className: 'block-title m9qynue8wk-editor_css',
            children: (
              <span>
                <span>
                  <span>
                    <p>{t('8YSmc1A23WXihcsgQfJB6')}</p>
                  </span>
                </span>
              </span>
            ),
          },
          post: {
            className: 'block-post',
            children: (
              <span>
                <p>
                  <br />
                </p>
              </span>
            ),
          },
          img: {
            className: 'block-img',
            children:
              'https://www.bmr-oe.com/static/images/app/展会.png',
          },
        },
      },
    ],
  },
});
export const Footer10DataSource = (t)=>({
  wrapper: { className: 'home-page-wrapper footer1-wrapper' },
  OverPack: { className: 'footer1', playScale: 0.2 },
  block: {
    className: 'home-page',
    gutter: 0,
    children: [
      {
        name: 'block0',
        xs: 24,
        md: 6,
        className: 'block',
        title: {
          className: 'logo',
          children:
            'https://www.bmr-oe.com/static/images/logo15.png',
        },
        childWrapper: {
          className: 'slogan',
          children: [
            {
              name: 'content0',
              children: (
                <span>
                  <p>{t('HU6ery8O_Do9EoDQUMRpI')}</p>
                </span>
              ),
              className: 'm8frbj7scy-editor_css',
            },
          ],
        },
      },
      {
        name: 'block1',
        xs: 24,
        md: 6,
        className: 'block',
        title: { 
          children: (
            <span >
              <p>{t('6In5IXCzAzXlElTLz3uKp')}</p>
            </span>
            ),
          },
        childWrapper: {
          children: [
            {
              name: 'link0',
              href: '/产品手册-V1.1.pdf',
              children: (
                <span>
                  <span>
                    <p>{t('-3XcjapSXGy3erQPxmBpC')}</p>
                  </span>
                </span>
              ),
            },
            {
              name: 'link2',
              href: '/接口定义-V1.0.pdf',
              children: (
                <span>
                  <span>
                    <span>
                      <p>{t('vQFUIMJhcnYshtywPI5vq')}</p>
                    </span>
                  </span>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block2',
        xs: 24,
        md: 6,
        className: 'block',
        title: {
          children: (
            <span>
              <p>{t('LXkz_wErtJi1kFvCNn6E1')}</p>
            </span>
          ),
        },
        childWrapper: {
          children: [
            {
              href: '/#/eighth',
              name: 'link0',
              children: (
                <span>
                  <span>
                    <p>{t('rXYRRpfZBr1ZGMLc7YVkR')}</p>
                  </span>
                </span>
              ),
            },
            {
              href: '/#/ninth',
              name: 'link1',
              children: (
                <span>
                  <p>{t('8nAgwPYQyoEZ9_YUwUCln')}</p>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block3',
        xs: 24,
        md: 6,
        className: 'block',
        title: {
          children: (
            <span>
              <p>{t('tMEXbn4Dse-ahTKd8q6cN')}</p>
            </span>
          ),
        },
        childWrapper: {
          children: [
            {
              href: '/#/seventh',
              name: 'link0',
              children: (
                <span>
                  <span>
                    <span>
                      <p>{t('5ec8EJGhbIeI2_-MAnbP5')}</p>
                    </span>
                  </span>
                </span>
              ),
            },
            {
              href: '/#/sixth',
              name: 'link1',
              children: (
                <span>
                  <span>
                    <span>
                      <p>{t('3v4RgXpnSbTpOnnj_E2xL')}</p>
                    </span>
                  </span>
                </span>
              ),
            },
          ],
        },
      },
    ],
  },
  copyrightWrapper: { className: 'copyright-wrapper' },
  copyrightPage: { className: 'home-page' },
  copyright: {
    className: 'copyright',
    children: (
      <span>
        <span>{t('YN8guGvxgo89G-Og77xUQ')}</span>
      </span>
    ),
  },
});
